export interface IFormQuestionOption {
  title: string;
  id?: number;
}

export interface IFormItemTypeParams {
  canceled?: string;
}

export interface IGetFormDataParams {
  id: string;
}

export const questionSelectType = ['MULTIPLE_SELECT', 'UNIQUE_SELECT'] as const;
export const questionTextType = ['TEXT', 'NUMERIC'] as const;

export type IQuestionSelectType = (typeof questionSelectType)[number];
export type IQuestionTextType = (typeof questionTextType)[number];

export function isSelectType(value: string): value is IQuestionSelectType {
  return questionSelectType.includes(value as IQuestionSelectType);
}

export type IQuestionType = IQuestionSelectType | IQuestionTextType;

export interface IQuestionItem<T = IQuestionType> {
  id: number;
  type: T;
  title: string;
  options: IFormQuestionOption[];
  answer?: IAnswerDetails;
}

export interface IAnswerDetails {
  text: string;
  selected: number[];
}

export interface IQuestionTypeSelectOptions {
  value: IQuestionType;
  label: string;
}

export interface IFormItemType {
  cdItem: number;
  label: string;
  value: IQuestionType;
}

export interface IQuestionnaireRequestData {
  id: string | undefined;
  title: string;
  description: string;
  required: boolean;
  startDate?: string | null;
  endDate?: string | null;
  supplierList?: number[];
  answered?: boolean;
  inCanceled?: 'S' | 'N';
  inDraft?: 'S' | 'N';
  inPublished?: 'S' | 'N';
  inInactive?: 'S' | 'N';
  questions: IQuestionItem[];
}

export interface ISupplierContact {
  ID_PESSOA: string;
  NM_PESSOA: string;
  RET_EMAIL_PESSOA: string;
  ID_TIPO_PESSOA: string;
  ID_TIPO_FORNECEDOR: string;
}
